module.exports = __webpack_public_path__ + "static/media/logo.bc1a0142.png";